import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Grid, TextField } from '@material-ui/core';

import ButtonsUseStyles from 'consts/styles/Buttons';
import Icons from 'consts/icons';
import { formStyles } from 'consts/styles/Form';
import { useSelector } from 'react-redux';
import { userStyles } from 'consts/styles/User';
import Container from '@material-ui/core/Container';

const ConfirmationModal = props => {
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  const { setChoice, currentStatus } = props;

  const subtitles = useSelector(state => state.language).confirmationModal;

  const [isInvalid, setIsInvalid] = React.useState(!currentStatus);

  const [currentMessage, setCurrentMessage] = React.useState(null);

  const onTextChange = event => {
    if (event.target.value) {
      setIsInvalid(false);
    } else {
      setIsInvalid(true);
    }
    setCurrentMessage(event.target.value);
  };

  return (
    <>
      <div className={classesUser.User}>
        <div className={`${classesUser.User}__settings`}>
          <div className={`${classesUser.User}__settings__content`}>
            <div className={`${classesUser.User}__settings__content__spacer`} />
            <Container>
              <Grid
                item
                xs
                className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
              >
                <div
                  className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}`}
                >
                  <Icons.Actions.DoneOutline />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}__text-field`}
                >
                  {subtitles.text_}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="outlined-multiline-static"
                  label={`${subtitles.approvalMsgLabel_} (${
                    !currentStatus ? subtitles.required_ : subtitles.optional_
                  })`}
                  multiline
                  rows={8}
                  placeholder={`${subtitles.approvalMsgLabel_} (${
                    !currentStatus ? subtitles.required_ : subtitles.optional_
                  })`}
                  variant="outlined"
                  error={isInvalid}
                  onChange={onTextChange}
                  fullWidth
                  InputLabelProps={{
                    classes: {
                      root: `${formClasses.Form}__text-field`,
                      formControl: `${formClasses.Form}__text-field`,
                      focused: `${formClasses.Form}__text-field--focused`,
                    },
                  }}
                  InputProps={{
                    classes: {
                      input: `${formClasses.Form}__text-field`,
                      focused: `${formClasses.Form}__text-field--focused`,
                    },
                  }}
                />
              </Grid>
            </Container>
            <div className={`${classesUser.User}__settings__content__spacer`} />
          </div>
        </div>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
                fullWidth
                onClick={() => setChoice(true, currentMessage)}
                disabled={isInvalid}
              >
                {subtitles.accept_}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} ${classesButtons.Buttons}--reject`}
                onClick={() => setChoice(false, null)}
              >
                {subtitles.cancel_}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
};

ConfirmationModal.propTypes = {
  setChoice: PropTypes.func.isRequired,
  currentStatus: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.oneOf([PropTypes.instanceOf(null)]).isRequired,
    PropTypes.bool.isRequired,
  ]),
};
export default ConfirmationModal;
